import { Injectable } from '@angular/core';
import { Observable, catchError, of, tap } from 'rxjs';
import { ApiService } from './api.service';
import { ToastService } from './toast.service';
import { ContactAddressModel } from '../models/contact.model';

@Injectable()
export class ContactService {
  clientsCache: Record<string, any> = {};

  constructor(
    private apiService: ApiService,
    private toastService: ToastService
  ) {}

  getContacts(): Observable<any> {
    return this.apiService.get<any>(`contact/get`, { showToast: false });
  }

  getContactsAndCases(term: string = ''): Observable<any> {
    // if term is empty we want all records but need a value to store it in the cache
    const cacheKey = term ? term : '__all__';

    // make search faster by using memory based cache. Handy for backspace usage etc.
    // Check if we have a cache record
    if (this.clientsCache[cacheKey]) {
      return of(this.clientsCache[cacheKey]);
    } else {
      return this._getContactsAndCases(term, cacheKey);
    }
  }

  getContactAddress(ctcId: string): Observable<ContactAddressModel> {
    return this.apiService.post<ContactAddressModel>('contact/getcontactaddress', { ctcId: ctcId });
  }

  private _getContactsAndCases(
    search: string,
    cacheKey: string
  ): Observable<any> {
    return this.apiService
      .post<any>(
        `contact/getwithcases`,
        { search: search },
        { showToast: false }
      )
      .pipe(
        tap((response) => {
          this.clientsCache[cacheKey] = response;
        }),
        catchError((error) => {
          //INTERNAL USE ONLY - DO NOT DISPLAY ERRORS TO END USER
          // this.toastService.show(error, {
          //   classname: 'bg-danger',
          //   autohide: false,
          // });
          return of([]); // Return an empty array on error
        })
      );
  }
}
